<template>
	<div class="type-text" :is="tag" :class="className" :style="styleText" @click="$emit('click', $event)">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'type-title',
		props: {
			tag: {
				type: String,
				default: 'div'
			},
			type: {
				type: String,
				default: 'content',
				validator: value => [ 'title', 'content' ].indexOf(value) > -1
			},
			size: {
				type: String, // max-title 1、 title 3、 subtitle 9、 content button input 6、 min-content 9
				default: '6',
				validator: value => [ '1', '2', '3', '4', '5', '6', '7', '8', '9', 'max' ].indexOf(String(value)) > -1
			},
			indent: {
				type: Boolean,
				default: false
			},
			align: {
				type: String, // title默认center  content默认left
				default: '' // https://www.w3school.com.cn/cssref/pr_text_text-align.asp
			},
			weight: {
				type: String, // title默认600  content默认300
				default: '' // https://www.w3school.com.cn/cssref/pr_font-weight.asp
			},
			margin: {
				type: String,
				default: ''
			},
			padding: {
				type: String, // title默认0 0 25px  content默认0 0 20px
				default: ''
			},
			lineHeight: {
				type: String, // title默认1.6  content默认1.4
				default: ''
			}
		},
		computed: {
			className() {
				let name = `${this.type}-text text-${this.type}-${this.size}`;
				return name;
			},
			styleText() {
				let text = '';
				if (this.margin) {
					text += `margin: ${this.margin};`;
				}
				if (this.indent) {
					text += `text-indent: 2em;`;
				}
				if (this.padding) {
					text += `padding: ${this.padding};`;
				} else {
					text += `padding: 0 0 ${this.type === 'title' ? '25px' : '20px'};`;
				}
				if (this.lineHeight) {
					text += `line-height: ${this.lineHeight};`;
				} else {
					text += `line-height: ${this.type === 'title' ? '1.6' : '1.4'};`;
				}
				if (this.align) {
					text += `text-align: ${this.align};`;
				} else {
					text += `text-align: ${this.type === 'title' ? 'center' : 'left'};`;
				}
				if (this.weight) {
					text += `font-weight: ${this.weight};`;
				} else {
					let weight = 500;
					if (this.type === 'title') {
						// max 900
						// 1 800
						// 2 700
						// 3 700
						// 4 600
						// 5 600
						// 6 500
						// 7 500
						// 8 400
						// 9 400
						if (this.size === 'max') {
							weight = 900;
						} else {
							weight = 800 - 100 * Math.floor(Number(this.size) / 2);
						}
					}
					// text += `font-weight: ${this.type === 'title' ? 'bold' : 'normal'};`;
					// text += `font-weight: ${this.type === 'title' ? '600' : '300'};`;
					text += `font-weight: ${weight};`;
				}
				return text;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-text{
		width: 100%;
	}
</style>